import { Injectable } from "@angular/core";
import { CodigosServiceBackend } from "@serviceBackends";
import { ClienteDTO, CodigoDTO, CodigoValorDTO } from "@DTOS";

@Injectable({
    providedIn: "root"
})
export class CodigosService {
    constructor(private codigosServiceBackend: CodigosServiceBackend) { }

    public async obtenerCodigos(): Promise<CodigoDTO[]> {
        return await this.codigosServiceBackend.getCodigos();
    }

    public async agregarCodigo(codigoValor: CodigoValorDTO, cliente: ClienteDTO): Promise<CodigoDTO> {
        return await this.codigosServiceBackend.agregarCodigo(codigoValor, cliente);
    }
}
